import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/logo_light_mode.png")